var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("system.role.placeholder")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearch($event)
                                }
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleSearch }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("system.user.query")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c("div", { staticClass: "otherActions" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "addEditOrDelete" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasUpdatePermission,
                              expression: "hasUpdatePermission"
                            }
                          ],
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleDialog("add")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.add")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasDeletePermission,
                              expression: "hasDeletePermission"
                            }
                          ],
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-delete"
                          },
                          on: { click: _vm.handleMultipleDelete }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("common.delete")) + "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    attrs: {
                      data: _vm.tableData,
                      fit: "",
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        align: "center",
                        width: "60",
                        fixed: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("system.role.roleName"),
                        align: "center",
                        prop: "roleName",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("system.codeSort.iniTableRemarkTitle"),
                        align: "center",
                        prop: "remark",
                        "min-width": _vm.customTableColumnWidth("lg") || 200
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("system.role.createTimeText"),
                        align: "center",
                        sortable: "",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.dateFormat(scope.row.createTime))
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("system.role.operationText"),
                        width: "400",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasViewPermission,
                                      expression: "hasViewPermission"
                                    }
                                  ],
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "success",
                                    icon: "el-icon-view",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDialog(
                                        "view",
                                        scope.row.roleId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("system.user.bView")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasUpdatePermission,
                                      expression: "hasUpdatePermission"
                                    }
                                  ],
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-edit-outline",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDialog(
                                        "edit",
                                        scope.row.roleId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("system.user.bEdit")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasDeletePermission,
                                      expression: "hasDeletePermission"
                                    }
                                  ],
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(scope.row.roleId)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("system.user.bDelete")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  attrs: {
                    total: _vm.totalData,
                    page: _vm.paginationOptions.page,
                    limit: _vm.paginationOptions.limit
                  },
                  on: { pagination: _vm.handlePagination }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "dialog"
        },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                id: "dialog",
                title: _vm.formTitle,
                visible: _vm.showDialog,
                width: "600px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showDialog = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "card" },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formTitle) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "close" }, [
                      _c("i", {
                        staticClass: "el-icon-close",
                        on: { click: _vm.closeDialog }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      attrs: {
                        disabled: _vm.viewOnly,
                        rules: _vm.rules,
                        model: _vm.formData,
                        "label-position": "left",
                        "label-width": "130px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.role.roleName"),
                            prop: "roleName"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.viewOnly, clearable: "" },
                            model: {
                              value: _vm.formData.roleName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "roleName", $$v)
                              },
                              expression: "formData.roleName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.role.roleDescription"),
                            prop: "remark"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              type: "textarea",
                              row: 2,
                              disabled: _vm.viewOnly
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("system.role.rolePermission"),
                            prop: "permissions"
                          }
                        },
                        [
                          _c(
                            "el-scrollbar",
                            { attrs: { "wrap-class": "scrollbar-wrapper" } },
                            [
                              _c("el-tree", {
                                ref: "tree",
                                attrs: {
                                  disabled: _vm.viewOnly,
                                  data: _vm.tree,
                                  "show-checkbox": "",
                                  "node-key": "id",
                                  "highlight-current": "",
                                  props: _vm.treeProps,
                                  "check-strictly": ""
                                },
                                on: { check: _vm.handleCheck }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.viewOnly
                    ? _c(
                        "div",
                        { staticClass: "confirm-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSubmit }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.formButton) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }